import SiteHeader from "@/pages/home/components/SiteHeader";
import Hero from "@/pages/home/components/Hero";
import EntryBoard from "@/pages/home/components/EntryBoard";
import Causes from "@/pages/home/components/Causes";
import FixGuide from "@/pages/home/components/FixGuide";
import DownloadSection from "@/pages/home/components/DownloadSection";
import PermanentEntry from "@/pages/home/components/PermanentEntry";
import Features from "@/pages/home/components/Features";
import Faq from "@/pages/home/components/Faq";
import SafetyTips from "@/pages/home/components/SafetyTips";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <SiteHeader />
      <main>
        <Hero />
        <EntryBoard />
        <Causes />
        <FixGuide />
        <DownloadSection />
        <PermanentEntry />
        <Features />
        <Faq />
        <SafetyTips />
      </main>
      <SiteFooter />
    </div>
  );
}